import React from 'react'
import PopularPlayers from './PopularPlayers'
import PopularCountries from './PopularCountries'
import DashboardChallenges from './DashboardChallenges'
import DashboardSearchedPositions from './DashboardSearchedPositions'
import DashboardGeneralStats from './DashboardGeneralStats'
import './dashboard.css'

export default function Dashboard() {
  return (
    <div className="dash-canvas">

      <DashboardGeneralStats/>

      <div className="grid grid-2">
        <DashboardSearchedPositions/>
        <PopularPlayers/>
      </div>

      <div className="grid grid-halves">
        <PopularCountries/>
        <DashboardChallenges/>
      </div>

    </div>
  )
}
